import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useOnboarding } from '../../../../context/OnboardingContext';
import { PrivateWizardLayout, WizardContainer, WizardCard, WizardActions } from '../../WizardLayout';
import Stepper from '../../Stepper';
import { toast } from 'react-toast';
import '../../../../styles/wizard.css';
import { useDownloadAgent, useGeneratePairingToken, useVerifyPairingToken } from '../../../../hooks/API/wizard.api';

const Step6IotLabAgent = () => {
  const navigate = useNavigate();
  const { iot, workspace, setIot, nextStep, previousStep ,markStepCompleted,goToStep} = useOnboarding();
  const [agentData, setAgentData] = useState(iot.labAgent);
  const { mutate: downloadAgent } = useDownloadAgent();
const [pairingToken, setPairingToken] = useState('');
const [labAgentToken, setLabAgentToken] = useState("");
const [isPairing, setIsPairing] = useState(false);
const [countdown, setCountdown] = useState(null); 
const [pairedDevice, setPairedDevice] = useState(null);
const [agentVersion, setAgentVersion] = useState(null);
const [selectedOs, setSelectedOs] = useState(1); // 1: Linux, 2: Windows, 3: macOS

const pairingTimeoutRef = useRef(null);
const countdownRef = useRef(null);
 


const { mutate, isLoading } = useGeneratePairingToken();
const { mutate: verifyToken } = useVerifyPairingToken();

const handleGeneratePairingToken = () => {
  mutate(undefined, {
   onSuccess: (res) => {
  setPairingToken(res.token);
window.postMessage({ source: "ROBITEST_CLOUD", action: "PAIR_LAB_AGENT" }, "*"); 
 setIsPairing(true);
  pairingTimeoutRef.current = setTimeout(() => {
    setIsPairing(false);
    toast.error('No response from extension. Is the Robitest extension installed?');
  }, 300000);
},
    onError: () => {
      toast.error('Failed to generate pairing token. Please try again.');
    },
  });
};

 

  useEffect(() => {
      if (agentData.connected) return;
      if (!pairingToken) return; 
      if (!labAgentToken) return;
      if (agentData.connected || !pairedDevice ) return;

      const payload = {
        device: pairedDevice,
        token: labAgentToken,
        os_type: selectedOs,
        agent_type: 2
      };
 
    verifyToken(payload, {
      onSuccess: (res) => {
        if (res.success) {
          // setCountdown(10);
                setAgentData(prev => ({ ...prev, connected: true }));
               setIot(prev => ({
        ...prev,
        labAgent: {
          ...prev.labAgent,
          connected: true,
          verified: true,
          
        }
      }));
          // countdownRef.current = setInterval(() => {
          //   setCountdown((prev) => {
          //     if (prev <= 1) {
          //       clearInterval(countdownRef.current);
          //       markStepCompleted(6);
          //       goToStep(7);
          //       navigate('/app/onboarding?step=7');
          //       return 0;
          //     }
          //     return prev - 1;
          //   });
          // }, 1000);
        }else{
          toast.error(res.error || 'Failed to verify pairing token. Please try again.');
        }
      },
      onError: () => {
        toast.error('Failed to verify pairing. Please try again.');
      },
    });
 
    return () => clearInterval(countdownRef.current);
  }, [agentData.connected,pairedDevice, selectedOs,labAgentToken]);

useEffect(() => {
    if (agentData.connected) return;

    const handlePairResult = (event) => {
        // CORRECT CHECK: Look inside event.data for our custom source string
        if (event.data?.source !== "ROBITEST_AGENT") return;

        // IGNORE PENDING: Only proceed if this is the success/detected event
        if (event?.data?.type === "LAB_PAIRING_PENDING") return;

        console.log(":white_check_mark: UI received pairing data:", event.data);

        clearTimeout(pairingTimeoutRef.current);

        // Map the payload keys from the bridge
        const payload = event.data.payload || event.data;

        if (event.data.success || payload.token) {
            setPairedDevice(payload.device);
            setIsPairing(false);
            setLabAgentToken(payload.token);
            setAgentVersion(payload.version);
            toast.success('Agent connected!');

            setIot(prev => ({
                ...prev,
                labAgent: {
                    ...prev.labAgent,
                    connected: false ,
                    deviceName: payload.device,
                    version: payload.version,
                }
            }));
        } else {
            setIsPairing(false);
            toast.error(event.data.error || 'Failed to pair Lab Agent.');
        }
    };

    window.addEventListener('message', handlePairResult);
    return () => {
      window.removeEventListener('message', handlePairResult);
      clearTimeout(pairingTimeoutRef.current);
    };
}, [agentData.connected]);
  

  const handleContinue = () => {
    if (!agentData.connected) {
      toast.error('Please connect the Lab Agent before continuing');
      return;
    }

      markStepCompleted(6);
      goToStep(7);
      navigate('/app/onboarding?step=7');
  };

const handleDownloadAgent = (os) => {
  setSelectedOs(os);
  downloadAgent(
    {
      os,
      agent_type: 2,
      // device_name: ,
    },
    {
      onSuccess: (response) => {
        console.log('Download response:', response);
        const downloadUrl = response?.agent_path;
        if (downloadUrl) {
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          toast.error('Download URL not found in response');
        }
      },
      onError: (error) => {
        console.error('Download failed:', error);
        toast.error('Failed to download agent. Please try again.');
      },
    }
  );
};
 


  const handleCopyToken = () => {
    navigator.clipboard.writeText(pairingToken);
    toast.success('Pairing token copied to clipboard');
  };

  return (
    <PrivateWizardLayout>
      <WizardContainer>
        <Stepper currentStep={6} completedSteps={[1, 2, 3, 4, 5]} />
        
        <WizardCard
          title="Connect your Hardware Test Lab"
          subtitle="Install the Lab Agent to enable hardware testing"
        >
          {!agentData.connected ? (
            <div>
              {/* Step 1: Download */}
              <div style={{
                marginBottom: '2rem',
                padding: '1.5rem',
                border: '1px solid var(--border-color)',
                borderRadius: '8px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  marginBottom: '1rem'
                }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'var(--primary-color)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '600',
                    fontSize: '0.875rem'
                  }}>
                    1
                  </div>
                  <h3 style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600' }}>
                    Download Lab Agent
                  </h3>
                </div>
                <p style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}>
                  Download and install the Robitest Lab Agent for your operating system
                </p>
                <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center' }}>
                  <button
                    className="wizard-btn wizard-btn-secondary"
                    style={{ flexShrink: 0, opacity: 0.6, cursor: 'not-allowed' }}
                    disabled
                    title="Coming Soon"
                  >
                    🪟 Download for Windows
                    <span style={{ color: 'red', fontWeight: 'bold', marginLeft: '0.25rem', cursor: 'help' }} title="Coming Soon">*</span>
                  </button>
                  <button
                    className="wizard-btn wizard-btn-secondary"
                    style={{ flexShrink: 0, opacity: 0.6, cursor: 'not-allowed' }}
                    disabled
                    title="Coming Soon"
                  >
                    🍎 Download for macOS
                    <span style={{ color: 'red', fontWeight: 'bold', marginLeft: '0.25rem', cursor: 'help' }} title="Coming Soon">*</span>
                  </button>
                  <button className="wizard-btn wizard-btn-secondary" style={{ flexShrink: 0 }}
                  onClick={() => handleDownloadAgent(1)}
                  >
                    🐧 Download for Linux
                  </button>
                </div>
              </div>

              {/* Step 2: Install */}
              <div style={{
                marginBottom: '2rem',
                padding: '1.5rem',
                border: '1px solid var(--border-color)',
                borderRadius: '8px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  marginBottom: '1rem'
                }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'var(--primary-color)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '600',
                    fontSize: '0.875rem'
                  }}>
                    2
                  </div>
                  <h3 style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600' }}>
                    Install & Start Agent
                  </h3>
                </div>
                <p style={{ margin: 0, color: 'var(--text-secondary)' }}>
                  Run the installer and start the Lab Agent service on your lab machine
                </p>
              </div>

              {/* Step 3: Pair */}
              <div style={{
                marginBottom: '2rem',
                padding: '1.5rem',
                border: '1px solid var(--border-color)',
                borderRadius: '8px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  marginBottom: '1rem'
                }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'var(--primary-color)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '600',
                    fontSize: '0.875rem'
                  }}>
                    3
                  </div>
                  <h3 style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600' }}>
                    Enter Pairing Token
                  </h3>
                </div>
                <p style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}>
                  Copy this token and paste it into the Lab Agent application
                </p>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'var(--bg-gray-900)',
                  borderRadius: '8px',
                  border: '1px solid var(--border-color)'
                }}>
                  <code
                style={{
                  flex: 1,
                  fontFamily: 'monospace',
                  fontSize: '1.5rem',
                  color: 'var(--success-color)',
                  letterSpacing: '0.1em',
                  fontWeight: '600'
                }}
              >
          {isLoading ? 'Generating...' : pairingToken || 'Click Generate'}
        </code>
                          <button
          onClick={handleGeneratePairingToken}
          disabled={isLoading || isPairing}
          className="wizard-btn wizard-btn-secondary"
        >
             🔄 {isLoading ? 'Generating' : 'Generate'}
        </button>
                  <button
                    onClick={handleCopyToken}
                    className="wizard-btn wizard-btn-secondary"
                    style={{ flexShrink: 0 }}
                  >
                    📋 Copy
                  </button>
                </div>
                <p style={{
                  marginTop: '0.5rem',
                  fontSize: '0.75rem',
                  color: 'var(--text-secondary)'
                }}>
                  Token expires in 5 minutes
                </p>
              </div>

              {/* Polling status */}
              {isPairing && (
                <div style={{
                  padding: '1.5rem',
                  background: 'rgba(76, 201, 240, 0.1)',
                  border: '1px solid rgba(76, 201, 240, 0.3)',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem'
                }}>
                  <div style={{
                    width: '24px',
                    height: '24px',
                    border: '3px solid rgba(76, 201, 240, 0.3)',
                    borderTopColor: 'var(--success-color)',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                  <div style={{ flex: 1 }}>
                    <p style={{ margin: 0, fontWeight: '500', color: 'var(--text-primary)' }}>
                      Waiting for agent connection...
                    </p>
                  </div>
                </div>
              )}
            </div>
          ) : (
            // Connected state
            <div style={{
              padding: '3rem',
              textAlign: 'center'
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 1.5rem',
                borderRadius: '50%',
                background: 'var(--success-bg)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2.5rem'
              }}>
                ✓
              </div>
              <h3 style={{
                fontSize: '1.75rem',
                fontWeight: '600',
                marginBottom: '1rem',
                color: 'var(--success-color)'
              }}>
                Lab Agent Connected
              </h3>
              <div style={{
                maxWidth: '400px',
                margin: '0 auto',
                padding: '1.5rem',
                background: 'var(--bg-gray-50)',
                borderRadius: '8px',
                textAlign: 'left'
              }}>
                <div style={{ marginBottom: '0.75rem' }}>
                  <strong style={{ color: 'var(--text-primary)' }}>Device:</strong>{' '}
                  <span style={{ color: 'var(--text-secondary)' }}>{pairedDevice || agentData.deviceName || 'Unknown'}</span>
                </div>
                <div style={{ marginBottom: '0.75rem' }}>
                  <strong style={{ color: 'var(--text-primary)' }}>Version:</strong>{' '}
                  <span style={{ color: 'var(--text-secondary)' }}>{ agentVersion||agentData.version || 'Unknown'}</span>
                </div>
                <div>
                  <strong style={{ color: 'var(--text-primary)' }}>Status:</strong>{' '}
                  <span style={{ color: 'var(--success-color)' }}>● Online</span>
                </div>
              </div>
            </div>
          )}

          <WizardActions
            showBack={true}
            onBack={() => {
              previousStep();
              navigate('/app/onboarding?step=5');
            }}
            showNext={true}
            onNext={handleContinue}
            nextLabel="Continue"
            nextDisabled={!agentData.connected}
          />
        </WizardCard>
      </WizardContainer>

      {/* Add spinner animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </PrivateWizardLayout>
  );
};

export default Step6IotLabAgent;